import { Attribute, VisualisationAttribute } from "konect-model";
import attributes from '../db/attributes.json';
import { Settings } from "../view/Settings";
import ApiService from "./api-service";

export default class AttributeService {
    private static apiService: ApiService = ApiService.getInstance();
    public static async getAttributes(): Promise<VisualisationAttribute[]> {
        try {

            if (Settings.useOfflineMode) {
                return attributes.map(attribute => {
                    const newAttribute = new Attribute();
                    // Explizite Typprüfung und Zuweisung
                    return Object.assign(newAttribute, {
                        ...attribute,
                        // Hier könnten weitere Validierungen erfolgen
                    }) as VisualisationAttribute;
                });
            }

            const response = await AttributeService.apiService.get("/attributes/all");
            // Validierung des API-Responses
            // If response is a number, it's an error status code - API layer already handled it
            if (typeof response === 'number') {
                throw new Error("Failed to load attributes - server error");
            }
            if (!Array.isArray(response)) {
                throw new Error("Ungültiges API-Response-Format");
            }

            return response;
        } catch (error) {
            console.error("Fehler beim Laden der Attribute:", error);
            throw error;
        }
    }


}